import { UseGetAllPageSizeProps } from '_api/queries/types';
import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Exercise } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_MY_LIBRARY_EXERCISES_KEY = 'get-my-library-exercises';

export const useGetMyLibraryExercises = ({
  page = 0,
  size = 10,
}: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Exercise[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/exercise/my-library?page=${page}&size=${size}`,
    {},
    [GET_MY_LIBRARY_EXERCISES_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
